import { colors } from '@material-ui/core';

import KaeserLogo from 'src/assets/kaeser_logo.png';
import KaeserIcon from 'src/assets/kaeser_favicon.png';

const kaeserBrandConfig = {
  urls: ['kaeser-no.prosaris.ca', 'kaeser-staging-us.prosaris.ca'],
  theme: {
    PRIMARY_COLOR: '#fdc700',
    PRIMARY_DARK: '#41616c',
    SECONDARY_COLOR: '#41616c',
    PRIMARY_TEXT: '#404040',
    ACCENT_TEXT: '#1D1F22',
    DARK_BACKGROUND: '#41616c',
    SUCCESS: '#0D7B3B',
    WARNING: '#B29600',
    ERROR: '#BD1717',
    BRANDING_MAIN: '#1D1F22',
    BRANDING_SHADE: '#191A1D',
    MAIN_LAYOUT: {
      BACKGROUND: '#FFC700',
      PRIMARY_COLOR: '#fdc700',
      PRIMARY_DARK: '#E6B300',
      SECONDARY_COLOR: '#fdc700',
      ACCENT_COLOR: '#ffffff',
      TEXT_PRIMARY: '#333740',
      TEXT_SECONDARY: '#333740',
      INPUT_BACKGROUND: '#ffffff',
      INPUT_BORDER: '#333740',
      BUTTON_BACKGROUND: '#333740',
      BUTTON_COLOR: '#ffffff',
      BUTTON_HOVER: '#1f2329',
    },
    UNIT_TOGGLE_BUTTON: {
      ACTIVE: {
        BACKGROUND: '#fdc700',
        COLOR: '#1D1F22',
        HOVER: {
          BACKGROUND: '#fdb500',
          COLOR: '#1D1F22',
        },
      },
      INACTIVE: {
        BACKGROUND: '#ffffff',
        COLOR: '#1D1F22',
        HOVER: {
          BACKGROUND: colors.grey[100],
          COLOR: '#1D1F22',
        },
      },
    },
    TOPBAR: {
      ACTIVE: {
        BACKGROUND: '#fdc700',
        COLOR: '#1D1F22',
      },
      INACTIVE: {
        BACKGROUND: '#1D1F22',
        COLOR: '#ffffff',
      },
      TEXT: '#ffffff',
    },
  },
  logo: {
    login: {
      src: KaeserLogo,
      height: 110,
      alt: 'KAESER Logo',
    },
    topbar: {
      src: KaeserLogo,
      height: 30,
      alt: 'KAESER Logo',
    },
    report: {
      src: KaeserLogo,
      height: 25,
      alt: 'KAESER Logo',
    },
    coverPage: {
      src: KaeserLogo,
      height: 45,
      alt: 'KAESER Logo',
    },
    favicon: {
      src: KaeserIcon,
    },
  },
  title: 'KAESER Dashboard',
  bannersEnabled: false,
  poweredByEnabled: true,
  ol1Enabled: true,
  overrideExistingRegistration: false,
  viewOnboardingProgress: false,
  companyInfo: {
    name: 'PROSARIS',
    email: 'support@prosaris.ca',
  },
};

export default kaeserBrandConfig;
